module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av249-dba8b933928ec79255898723de61873c.jpg";